import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationFolateCombined from "./index";

const MethylationFolateWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationFolateCombined}
    keyControlsId="methylation-folate-key"
    {...props}
  />
);

export default MethylationFolateWithToggleKey;
